import { updateExpense } from '#/graphql/mutations';
import type { Expense, UpdateExpenseMutation } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import { useCallback } from 'react';
import { GET_EXPENSE } from './useExpenseQuery';

const q = gql(updateExpense);

const useExpenseUpdate = () => {
  const [mutation, result] = useMutation<UpdateExpenseMutation>(q);

  const updateExpense = useCallback(
    async (expenseId: string, expense: Expense) => {
      const {
        __typename,
        id,
        tenantId,
        createdAt,
        displayNumber,
        createdBy,
        updatedAt,
        updatedBy,
        tenant,
        updatedByUser,
        user,
        workOrder,
        purchaseOrderId,
        ...expenseInput
      } = expense;

      const response = await mutation({
        variables: {
          id: expenseId,
          data: expenseInput,
        },
        refetchQueries: [{ query: GET_EXPENSE, variables: { id: expenseId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateExpense', undefined);
    },
    [mutation],
  );

  return { updateExpense, result };
};

export default useExpenseUpdate;
